class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    // Now that the element is connected and its children are in place,
    // check for the URL query parameter.
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('cart') === 'open') {
      this.open();
    }
    this.querySelector('#CartDrawer-Overlay')?.addEventListener(
      'click',
      this.close.bind(this)
    );
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    this.attachCartIconListeners(cartLink);
  }

  attachCartIconListeners(cartLink) {
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

   // document.body.classList.add('overflow-hidden');

   // Add ?cart=open to URL
   this.updateCartURL(true);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    // Remove ?cart=open from URL
    this.updateCartURL(false);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  updateCartURL(isOpen) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (isOpen) {
      // Add cart=open parameter
      params.set('cart', 'open');
    } else {
      // Remove cart parameter
      params.delete('cart');
    }

    // Build new URL
    const newSearch = params.toString();
    const newURL = `${url.pathname}${newSearch ? '?' + newSearch : ''}${url.hash}`;

    // Update URL without page reload
    history.replaceState({}, '', newURL);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      // sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (sectionElement && parsedState.sections[section.id]) {
        const newHtml = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
        if (section.id === 'cart-icon-bubble') {
          const newBubble = new DOMParser()
            .parseFromString(newHtml, 'text/html')
            .querySelector('#cart-icon-bubble');
          if (newBubble) {
            const parent = sectionElement.parentNode;
            console.log("replace ", newBubble, sectionElement);
            parent.replaceChild(newBubble, sectionElement);
            newBubble.setAttribute('role', 'button');
            newBubble.setAttribute('aria-haspopup', 'dialog');
            this.attachCartIconListeners(newBubble);
          }
        } else {
          console.log("replace 2", sectionElement);
          sectionElement.innerHTML = newHtml;
        }
      }
    });

    const mobileCartOpener = document.querySelector('#cart-icon-button');
    mobileCartOpener.addEventListener('click', (event) => {
      const cartDrawer = document.querySelector('cart-drawer');
      cartDrawer.open();
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this)
      );
      //atc-popup
     if (typeof enableAddToCartNotification === "undefined" || enableAddToCartNotification === false) {
      this.open();
      }
      //atc-popup end
    });
   console.log("renderContents");
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-icon-button',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-button',
        section: 'cart-icon-button',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
